import { motion } from 'framer-motion';
import { CheckCircleIcon, ClockIcon } from '@heroicons/react/24/outline';
import { roadmapData } from '../../data/roadmap';
import RoadmapPhase from './RoadmapPhase';

export default function RoadmapTimeline() {
  return (
    <div className="space-y-16 mb-16">
      {roadmapData.map((phase, phaseIndex) => (
        <motion.div
          key={phase.period}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: phaseIndex * 0.1 }}
        >
          <RoadmapPhase 
            phase={phase} 
            isCompleted={phase.period.includes('2024')}
            icon={phase.period.includes('2024') ? CheckCircleIcon : ClockIcon}
          />
        </motion.div>
      ))}
    </div>
  );
}